<template>
    <div class="land-gallery">
        <div class="container">
            <div class="section-title">
                <h2>{{salesCard.gallery_section_title}}</h2>
            </div>
            <div class="gallery-carousel">
                <swiper :options="swiperOption" ref="landGalleryCarousel">
                    <swiper-slide v-for="(slide, index) in salesCard.gallery_images" :key="index" @click.native="openModal(index)">
                        <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                        <div class="resize-btn">
                            <svgIcon name="resize-gal" class="icon-resize-gal"/>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
            <div class="swiper-controls sales-land-controls sales-land-gallery-controls">
                <div class="sales-land-btn-prev sales-land-gallery-btn-prev slider-btn">
                    <svgIcon name="left-arrow" />
                </div>
                <div class="sales-land-btn-next sales-land-gallery-btn-next slider-btn">
                    <svgIcon name="right-arrow" />
                </div>
            </div>
        </div>
        <div class="modal-gal" v-if="initModalGal && !isMobileChecker">
            <galleryLand :images="salesCard.gallery_images" :index="indexActive" @close="indexActive = null" class="gallery-modal-biggest" @onopen="openGalModal" @onclosed="closeGalModal"></galleryLand>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import VueGallery from 'vue-gallery';
    export default {
        name: 'sale-land-gallery',
        components: {
            svgIcon,
            'galleryLand': VueGallery,
        },
        data () {
            return {
                indexActive: null,
                initModalGal: false,
                projectNameG: window.host,
                swiperOption: {
                    // speed: 800,
                    loop: true,
                    // observer: true,
                    // observeParents: true,
                    effect: 'coverflow',
                    centeredSlides: true,
                    slidesPerView: "auto",
                    initialSlide: 1,
                    coverflowEffect: {
                        rotate: 0,
                        stretch: -50,
                        depth: 500,
                        modifier: .5,
                        slideShadows: false,
                    },
                    // slidesPerView: 1,
                    // simulateTouch: false,
                    // watchSlidesVisibility: true,
                    // lazy: {
                    //     loadPrevNext: true,
                    //     loadOnTransitionStart: true
                    // },
                    // autoplay: {
                    //     delay: 3500,
                    //     disableOnInteraction: true,
                    // },
                    navigation: {
                        nextEl: '.sales-land-gallery-btn-next',
                        prevEl: '.sales-land-gallery-btn-prev',
                    },
                    // pagination: {
                    //     el: '.sales-land-lobbi-pagination',
                    //     type: 'bullets',
                    //     clickable: true,
                    // },
                },
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            openModal(index) {
                this.initModalGal = true;
                setTimeout(() => {
                    this.indexActive = index
                }, 200);
            },
            openGalModal() {
                document.getElementById('land-gallery').classList.add('openGallery');
                document.getElementById('header').classList.add('notvisible');
                document.getElementById('footer').classList.add('notvisible');
            },
            closeGalModal() {
                document.getElementById('land-gallery').classList.remove('openGallery');
                document.getElementById('header').classList.remove('notvisible');
                document.getElementById('footer').classList.remove('notvisible');
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-gallery.scss';
    @import '@/styles/components/sales/respond/land-gallery-respond.scss';
</style>